exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_box[data-v-508dc4c6]{overflow:hidden}.tip[data-v-508dc4c6]{background:#fafafa;padding:.12rem .5rem;display:flex;font-size:.16rem;font-family:Roboto-Regular,Roboto;font-weight:400;color:rgba(0,0,0,.85);line-height:.28rem}.tip p[data-v-508dc4c6]:first-child{width:.6rem}", ""]);

// exports
